module.exports = __webpack_public_path__ + "img/dostavka.b4c53111.png";